import React, { ReactElement, useState } from 'react';
import { OrganizationEventsModal } from 'components/ui';
import { OrganizationSummary } from 'services/api/models';

export interface OrgModalTarget {
  id: string;
  name: string;
  logoUrl: string;
  schoolSlug?: string;
}

export interface UseOrgModalResult {
  openOrg: (org: OrganizationSummary | OrgModalTarget) => void;
  orgModal: ReactElement | null;
}

const toTarget = (
  org: OrganizationSummary | OrgModalTarget,
): OrgModalTarget => ({
  id: org.id,
  name: org.name,
  logoUrl: org.logoUrl,
  schoolSlug:
    'schoolSlug' in org
      ? org.schoolSlug
      : (org as OrganizationSummary).school?.slug,
});

/**
 * Shared modal controller so event/org cards can launch the
 * OrganizationEventsModal when their host icon/name is clicked.
 */
export const useOrgModal = (): UseOrgModalResult => {
  const [selected, setSelected] = useState<OrgModalTarget | null>(null);
  const [open, setOpen] = useState(false);

  const openOrg = (org: OrganizationSummary | OrgModalTarget): void => {
    setSelected(toTarget(org));
    setOpen(true);
  };

  const orgModal = selected ? (
    <OrganizationEventsModal
      open={open}
      onClose={() => setOpen(false)}
      organizationId={selected.id}
      organizationName={selected.name}
      organizationLogoUrl={selected.logoUrl}
      schoolSlug={selected.schoolSlug}
    />
  ) : null;

  return { openOrg, orgModal };
};
